/**
 * Keeps track of which font face CSS rules have been added, so that slideshows
 * sharing a font don't add it twice. Shared across all slideshows on the page.
 */
export class FontFaceManager {
  /** @type {Set<string>} */
  addedFontNames = new Set();

  /**
   * @param {fontFaceParams} fontFaceParams
   */
  add(fontFaceParams) {
    if (this.addedFontNames.has(fontFaceParams.cssName)) {
      return;
    }
    this.addedFontNames.add(fontFaceParams.cssName);

    const urls = fontFaceParams.urls ?? [fontFaceParams.url];
    const src = urls
      .map((url) => {
        const format = url.match(/\.woff2(\?.*)?$/) ? "woff2" : "woff";
        return `url('${url}') format('${format}')`;
      })
      .join(", ");

    this.addCss(
      `/* added by FontFaceManager */\n` +
        `@font-face { font-family: '${fontFaceParams.cssName}'; src: ${src}; }`,
    );
  }

  addCss(rule) {
    const styleElement = document.createElement("style");
    styleElement.appendChild(document.createTextNode(rule));
    document.head.appendChild(styleElement);
  }
}

export const fontFaceManager = new FontFaceManager();

window.fontFaceManager = fontFaceManager;
